import { User } from "@/entities/user/user"
import { UserSmallProfile } from "./UserSmallProfile"

export function UserCard({
   user,
   badge,
   children,
}: {
   user: User
   badge?: React.ReactNode
   children?: React.ReactNode
}) {
   return (
      <div className="card bg-base-100 shadow-lg hover:shadow-xl transition-shadow">
         <div className="card-body p-4">
            <div className="flex items-center justify-between gap-3">
               <UserSmallProfile user={user} />
               {badge}
            </div>
            {children}
         </div>
      </div>
   )
}
